// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".screenshots-fiexd {\n  top: 0;\n  position: fixed;\n  z-index: -1;\n  height: 0;\n  overflow: hidden;\n}", ""]);
// Exports
module.exports = exports;
